<template>
  <div class="content-wrap content-wrap--summary bg-blue">
      <div class="sidebar sidebar--disable" id="sidebar">
        <header id="header" class="header">
          <div class="container container--centered">
            <div class="header__wrap">
              <div class="header__logo">
                <a href="/"><img :src="logoPath() + '/templates/agila/images/logo.png'" alt="Agila Haustlerversicherung" /></a>
              </div>
              <div class="header__link">
                  <span v-on:click="back(3, 'zahlung'); pushDataLayer('ecommerce', 'go_back', 'zahlung')" class="back-link"><span class="back-link__icon icon-left-arrow"></span>Zurück</span>
              </div>
            </div>
          </div>
        </header>
      </div>

        <section class="content-section">
          <span class="loader">
            <span style="width: 92.5%"></span>
          </span>
          <div class="container">

            <div class="step-indicator only-mobile">Schritt {{ isHPS(leadin) ? '4 / 4' : '5 / 5'}}</div>
            <div class="content__topbar" id="topbar">
              <span class="topbar__txt">Online-Antrag</span>
            </div>
            <div class="content__heading">
              <h1>Zusammenfassung</h1>
            </div>
          </div>
          <form class="info-form form">
            <div class="container form__upper">
              <div class="form__section">
                <div class="form__title form__title--edit">
                  <h2>Gewählter Tarif</h2>

                </div>
                <div class="card card--rounded card--small">
                  <div class="card__header">
                    <strong class="card__title">{{ leadin.productName }}</strong>
                    <p class="card__subtitle">
                      <span>{{ productPrice | replacePoint }} €</span> {{ paymentInterval }}
                    </p>
                  </div>
                  <div class="card__body" v-html="leadin.productInfo">
                  </div>
                </div>
                <div class="card card--rounded card--small" v-if="crossP.id && optimizely46 > 0">
                  <div class="card__header">
                    <strong class="card__title">{{ crossP.name }}</strong>
                    <p class="card__subtitle">
                      <span>{{ crossP.price | replacePoint }} €</span> {{ paymentInterval }}
                    </p>
                  </div>
                  <div class="card__body" v-html="crosssellingInfo">
                  </div>
                </div>
              </div>
              <!--<div class="form__section" v-if="leadin.race == 1 && (leadin.hashR == undefined || leadin.hashR == false)">-->
              <div class="form__section" v-if="leadin.race == 1 && (leadin.hashR == undefined || leadin.hashR == false)">
                <div class="form__title form__title--protection-options has-tooltip-icon" v-if="leadin.risk_id == undefined && leadin.risk_id != '' && !isHPS(leadin)">
                  <h2>
                    Clever kombinieren <span v-if="!is24"> & sparen</span>
                   </h2>
                  <span class="icon icon-question-mark icon-circle icon--light-blue tooltip" @click="tooltips.combi = !tooltips.combi"></span>
                  <span class="tooltiptext" v-if="tooltips.combi">Wenn Sie den gewünschten Tarif mit einem zusätzlichen Haftpflichtschutz kombinieren, bekommen Sie einen Rabatt von 50% auf den Jahresbeitrag der Haftpflichtversicherung (ausgenommen Tierkrankenschutz 24 und OP-Kostenschutz 24).</span>
                </div>
                <div class="protection-options" v-if="leadin.race == 1">
                  <ul class="protection-options__list"  v-if="leadin.risk_id == undefined && leadin.risk_id != '' && !isHPS(leadin)">
                    <li class="protection-options__item" v-for="(onecross, index) in cross" v-bind:key="index">
                      <Crossselling :registry="registry" v-model="leadin" :cross="onecross" ref="advanceCross" v-on:crosssellingCheck="crosssellingCheck($event)" /></li>
                    <li class="protection-options__item" v-if="cross.length && optimizely46 === 2">
                      <Crossselling :registry="registry" v-model="leadin" :cross="{id: 5, cdiscount: 0, pdiscount: 0, combi: 5}" ref="advanceCross" v-on:crosssellingCheck="crosssellingCheck($event)" :isSale="false" />
                    </li>
                  </ul>
                  <div class="
                        protection-options__contribution-amount
                        contribution-amount
                      ">
                    <dl class="contribution-amount__item">
                      <dt>{{ leadin.productName }}</dt>
                      <dd>{{ productPrice | replacePoint }}&nbsp;€</dd>
                    </dl>
                    <dl class="contribution-amount__item" v-if="crossP.id != ''">
                      <dt>{{ crossP.name }}</dt>
                      <dd>{{ crossP.price | replacePoint }}&nbsp;€</dd>
                    </dl>
                    <dl class="contribution-amount__item" v-if="combiP.id != ''">
                      <dt>{{ combiP.name }}</dt>
                      <dd>{{ combiP.price | replacePoint }}&nbsp;€</dd>
                    </dl>
                    <dl class="
                          contribution-amount__item
                          contribution-amount__item--total
                        ">
                      <dt>Ihr monatlicher Beitrag:</dt>
                      <dd>{{ displayedPrice | replacePoint }}&nbsp;€</dd>
                    </dl>
                  </div>
                </div>
              </div>
              <div class="form__section form__section--filled-data">
                <div class="form__title">
                  <h2>Persönliche Daten</h2>
                </div>
                <div class="filled-data">
                  <ul class="filled-data__list">
                    <li class="filled-data__item">
                      <h3 class="filled-data__title">Angaben zum Tier</h3>

                      <div class="filled-data__wrapper">
                        <ul>
                          <li>{{ leadin.petname }}</li>
                          <li>{{ leadin.petgender | setgender }}, {{ leadin.breed }}</li>
                        </ul>
                        <ul>
                          <li>geboren am {{ leadin.petbirthday | sortdate }}</li>
                          <li>Fellfarbe: {{ leadin.petcolour }}</li>
                        </ul>
                      </div>
                      <span class="filled-data__info-edit" v-on:click="back(0, 'tier'); pushDataLayer('ecommerce','edit_details', 'tier')" v-if="leadin.token == undefined || leadin.token == ''">
                        <i class="icon-pen"></i>
                      </span>
                    </li>
                    <li class="filled-data__item" v-if="!isHPS(leadin)">
                      <h3 class="filled-data__title">Angaben zur Gesundheit</h3>

                      <div>
                        <ul>
                          <li>Vorerkrankungen: <span v-if="leadin.healthElements && leadin.healthElements.length">{{ leadin.healthElements.map(obj => obj.description || obj.preCondition.name).join(', ') }}</span><span v-else>keine</span></li>
                          <li>Symptome: <span v-if="leadin.symptomElements && leadin.symptomElements.length">{{ leadin.symptomElements.map(obj => obj.name).join(', ') }}</span><span v-else>keine</span></li>
                        </ul>
                      </div>
                      <span class="filled-data__info-edit" v-on:click="back(2, 'gesundheit'); pushDataLayer('ecommerce','edit_details', 'gesundheit')" v-if="leadin.token == undefined || leadin.token == ''">
                        <i class="icon-pen"></i>
                      </span>
                    </li>
                    <li class="filled-data__item">
                      <h3 class="filled-data__title">Persönliche Daten</h3>
                      <div class="
                            filled-data__wrapper filled-data__wrapper--columns
                          ">
                        <ul>
                          <li>{{ leadin.gender }} {{ leadin.firstname }} {{ leadin.lastname }}</li>
                          <li>geboren am {{ leadin.birthday | sortdate }}</li>
                          <li>{{ leadin.email }}</li>
                          <li>{{ leadin.phone }}</li>
                        </ul>
                        <ul>
                          <li>{{ leadin.street }} {{ leadin.number }}</li>
                          <li>{{ leadin.zip }} {{ leadin.city }}</li>
                          <li>{{ leadin.country }}</li>
                        </ul>
                      </div>
                      <span class="filled-data__info-edit" v-on:click="back(1, 'persoenliche-daten'); pushDataLayer('ecommerce','edit_details', 'persoenliche-daten')" v-if="leadin.token == undefined || leadin.token == ''">
                        <i class="icon-pen"></i>
                      </span>
                    </li>
                    <li class="filled-data__item">
                      <h3 class="filled-data__title">Zahlung</h3>
                      <div class="filled-data__wrapper">
                        <ul>
                          <li>{{ leadin.paymentType | completePaymentType }}</li>
                          <li v-if="leadin.paymentType == 'ls'">{{ leadin.iban }}</li>
                          <li>{{ leadin.paymentinterval | paymentInterval }} Zahlung</li>
                        </ul>
                      </div>
                      <span class="filled-data__info-edit" v-on:click="back(isHPS(leadin) ? '2' : '3', 'zahlung'); pushDataLayer('ecommerce','edit_details', 'zahlung')">
                        <i class="icon-pen"></i>
                      </span>
                    </li>
                  </ul>

                </div>
              </div>
              <div class="form__section form__section--agreement" v-if="showIDD">
                <div class="form__title">
                  <h2>Beratungsverzicht</h2>
                </div>
                <div class="agreement">
                  <div class="agreement__confirmation">
                   <label class="custom-checkbox" @click="errorExIdd = true" >
                      <input type="checkbox"  v-model="idd" v-on:input="pushDataLayer('ecommerce','beratungsverzicht', !idd)" />
                      <span class="fake-checkbox">
                        <i class="icon-check"></i>
                      </span>
                      <span class="fake-label gray-label just ">
                        Ich verzichte ausdrücklich auf eine Beratung und Dokumentation durch den Versicherer, obwohl ich die Möglichkeit einer Beratung habe und mir bekannt ist, dass sich ein Verzicht nachteilig auf meine Möglichkeit auswirken kann, gegen den Versicherer Schadensersatz wegen Verletzung der Beratungs- und Dokumentationspflichten geltend zu machen.
                        <br/><span v-if="early == false">Gerne beraten wir Sie! Buchen Sie jetzt ein persönliches <a href="/Beratung" target="_blank">Beratungsgespräch</a>, nutzen Sie unseren <span class="hand" v-on:click="triggerChat()">Chat</span> oder rufen uns werktags in der Zeit von 09:00 bis 17:00 Uhr unter der Nummer <a v-if="country != 'Österreich'" href="tel:+49 511 93680377">+49 511 93680377</a><a v-if="country == 'Österreich'" href="tel:00800-71280-345">00800-71280-345</a> an.</span>
                        <span v-if="early == true">Gerne beraten wir Sie! Buchen Sie jetzt ein persönliches <a href="/Beratung" target="_blank">Beratungsgespräch</a> oder nutzen Sie unseren <span class="hand" v-on:click="triggerChat()">Chat</span>.</span>
                      </span>
                    </label>
                      <span :class="{'error-block': true, 'hidden': errorExIdd}">
                        <span  class="icon set-fas"><span class="glyph" ></span></span>
                        <span class="error"><span class="text">Bitte bestätigen Sie ihren Beratungsverzicht.</span></span>
                       </span>
                  </div>
                </div>
                <div class="agreement__attachments attachments">
                  <ul class="attachments__list">
<!--                    <li class="attachments__item">-->
<!--                      <a :href="'//www.agila.de/images/pdf/' + retPdf " class="attachments__link" target="_blank">-->
<!--                          <span class="attachments__download">-->
<!--                            <i class="icon-download"></i>-->
<!--                          </span>-->
<!--                        <p class="attachments__label">-->
<!--                          {{ retraction }}-->
<!--                        </p>-->
<!--                      </a>-->
<!--                    </li>-->
<!--                    <li class="attachments__item">-->
<!--                      <a :href="'//www.agila.de/images/pdf/' + pdfDS " class="attachments__link" target="_blank">-->
<!--                          <span class="attachments__download">-->
<!--                            <i class="icon-download"></i>-->
<!--                          </span>-->
<!--                        <p class="attachments__label">-->
<!--                          Hinweise zum Datenschutz-->
<!--                        </p>-->
<!--                      </a>-->
<!--                    </li>-->
                    <li class="attachments__item">
                      <a :href="'//www.agila.de/images/pdf/' + pdf " class="attachments__link" target="_blank">
                          <span class="attachments__download">
                            <i class="icon-download"></i>
                          </span>
                        <p class="attachments__label">
                          Versicherungsbedingungen (AVB) und Informationsblätter (IPID)
                        </p>
                      </a>
                    </li>
<!--                    <li class="attachments__item">-->
<!--                        <span class="attachments__link" @click="getPDF()" target="_blank">-->
<!--                          <span class="attachments__download">-->
<!--                            <i class="icon-download"></i>-->
<!--                          </span>-->
<!--                          <p class="attachments__label">Ihre Antragsdaten drucken</p>-->
<!--                        </span>-->
<!--                    </li>-->
<!--                    <li class="attachments__item">-->
<!--                      <a :href="'//www.agila.de/images/pdf/' + preContractPdf" class="attachments__link" target="_blank">-->
<!--                          <span class="attachments__download">-->
<!--                            <i class="icon-download"></i>-->
<!--                          </span>-->
<!--                        <p class="attachments__label">-->
<!--                          Mitteilung zur vorvertraglichen Anzeigenpflicht nach {{ leadin.country === 'Österreich' ? '§ 16 – 22 VersVG' : '§ 19 Abs. 5 VVG'}}-->
<!--                        </p>-->
<!--                      </a>-->
<!--                    </li>-->
                  </ul>
                </div>
              </div>
              <div class="form__section form__section--agreement">
                <div class="form__title">
                  <h2>Einverständnis</h2>
                </div>
                <p v-if="optimizelyIsVariant(5597786670891008, 5723948164317184)">
                  <label class="custom-checkbox">
                    <input type="checkbox" v-model="digitalCommunication" id="cbDigitalCommunication" />
                    <span class="fake-checkbox">
                      <i class="icon-check"></i>
                    </span>
                    <span class="fake-label gray-label inline-checkbox"
                    >Ja, ich möchte in Zukunft alle Mitteilungen zu meinem Vertrag per E-Mail erhalten. Meine Zustimmung zur digitalen Vertragskommunikation kann ich jederzeit über das Help Center widerrufen. (optional)</span>
                  </label>
                </p>
                <div class="agreement">
                  <div class="agreement__confirmation">
                    <label class="custom-checkbox" @click="errorEx = true" >
                      <input type="checkbox"  v-model="accept" v-on:input="pushDataLayer('ecommerce','einverstaendnis', !accept)"/>
                      <span class="fake-checkbox">
                        <i class="icon-check"></i>
                      </span>
                      <span class="fake-label gray-label">
                        Ich bestätige die Kenntnisnahme und Abgabe
                        nachfolgender Erklärungen.&nbsp;
                      </span>
                    </label>
                    <span :class="{'error-block': true, 'hidden': errorEx}">
                        <span  class="icon set-fas"><span class="glyph" ></span></span>
                        <span class="error"><span class="text">Sie müssen Ihr Einverständnis bestätigen!</span></span>
                       </span>
                  </div>
                  <div class="tabs__info">
                    <div class="jcf-scrollable just pad-right" v-html="disclaimerText">

                    </div>
                  </div>
                </div>
              </div>
                  <div class="form__section open-close" v-if="showIDD">
                    <div class="filled-data__confirmation">
                      <label class="custom-checkbox">
                        <input type="checkbox" v-model="isBroker" v-on:input="pushDataLayer('ecommerce','isBroker', !isBroker)" />
                        <span class="fake-checkbox" >
                          <i class="icon-check"></i>
                        </span>
                        <span class="fake-label gray-label">Sind Sie Versicherungsmakler oder Vermittler? (optional)</span>
                      </label>
                    </div>
                    <div :class="{'fieldset': true,  'form--medium': true, 'indent': true, 'hidden': !isBroker, 'form--unlarge': true}">
                      <a-input label="Vermittlernummer" v-model="brokerID" type="select" :options="brokerList" @blur="pushDataLayer('ecommerce','brokerID', brokerID)" />
                    </div>
                  </div>

                  <template v-if="(campaignCheckbox && puppyCheckbox) || (campaignCheckbox && seoIncentiveCheckbox || (puppyCheckbox && seoIncentiveCheckbox))">
                      <h2>Ihre Prämie zum Vertragsabschluss</h2>
                      <div class="form__section incentive" >
                        <a-checkbox radio v-model="sendCampaignPackage" label="Ich möchte das Zahnputzset erhalten. Weiterhin bestätige ich, dass meine Adresse richtig ist. Ansonsten wird das Paket nicht versendet oder nachgesendet." value="2503" :size="16" v-if="campaignCheckbox" />
                        <a-checkbox radio v-model="sendCampaignPackage" label="Ich möchte den 15 € Wunschgutschein erhalten. <a href='https://www.agila.de/images/pdf/AGILA_Teilnahmebedingungen_Wunschgutschein.pdf' target='_blank'>Teilnahmebedingungen</a>" value="seo_incentive" :size="16" v-if="seoIncentiveCheckbox"/>
                        <a-checkbox radio v-model="sendCampaignPackage" label="Ich möchte das AGILA Willkommenspaket für meinen Welpen oder mein Kitten erhalten. Zudem bestätige ich, dass meine Adresse richtig ist. Ansonsten wird das Paket nicht versendet bzw. erfolgt bei falscher Adressangabe kein erneuter Versand des Pakets." value="puppy" :size="16" v-if="puppyCheckbox"/>
                      </div>
                  </template>

                  <div class="form__section" v-else-if="seoIncentiveCheckbox">
                    <label class="custom-checkbox">
                      <input type="checkbox" v-model="sendCampaignPackage" :value="'seo_incentive'" />
                      <span class="fake-checkbox" >
                            <i class="icon-check"></i>
                          </span>
                      <span class="fake-label gray-label">Ich möchte den 15 € Wunschgutschein erhalten. <a href="https://www.agila.de/images/pdf/AGILA_Teilnahmebedingungen_Wunschgutschein.pdf" target="_blank">Teilnahmebedingungen</a></span>
                    </label>
                  </div>
                  <div class="form__section" v-else-if="campaignCheckbox">
                    <label class="custom-checkbox">
                      <input type="checkbox" v-model="sendCampaignPackage" :value="'2503'" />
                      <span class="fake-checkbox" >
                        <i class="icon-check"></i>
                      </span>
                      <span class="fake-label gray-label">Ich möchte das Zahnputzset erhalten.</span>
                    </label>
                    <div class="checkbox-subtext">Weiterhin bestätige ich, dass meine Adresse richtig ist. Ansonsten wird das Paket nicht versendet oder nachgesendet.</div>
                  </div>
                  <div class="form__section" v-else-if="puppyCheckbox">
                    <label class="custom-checkbox">
                      <input type="checkbox" v-model="sendCampaignPackage" :value="'puppy'" />
                      <span class="fake-checkbox" >
                            <i class="icon-check"></i>
                          </span>
                      <span class="fake-label gray-label">Ich möchte das AGILA Willkommenspaket für meinen Welpen oder mein Kitten erhalten.</span>
                    </label>
                    <div class="checkbox-subtext">Zudem bestätige ich, dass meine Adresse richtig ist. Ansonsten wird das Paket nicht versendet bzw. erfolgt bei falscher Adressangabe kein erneuter Versand des Pakets.</div>
                  </div>
                  <info-block :show-info-icon="false">
                    Sie können den Vertrag erst nach dem Herunterladen der Vertragsunterlagen abschließen.<br><br>
                    Ich bestätige das nachfolgende Dokument heruntergeladen und gespeichert bzw. ausgedruckt zu haben. Bitte lesen Sie das Dokument aufmerksam durch. Die Bestätigung der Kenntnisnahme und Speicherung ist aus Informations- und Dokumentationspflichten notwendig.<br><br>
                    <div class="attachments">
                      <ul class="attachments__list">
                        <li>
                          <span :class="{'error-block': true, 'hidden': errorDocuments}" style="margin: 0 0 10px;">
                                <span  class="icon set-fas"><span class="glyph" ></span></span>
                                <span class="error">
                                   <span class="text">Bitte zuerst die benötigten Unterlagen herunterladen:</span>
                                </span>
                          </span>
                        </li>
                        <li class="attachments__item">
                          <a @click="downloadAllDocuments()" target="_blank" style="display: flex">
                            <span class="attachments__download">
                              <i class="icon-download"></i>
                            </span>
                            <p class="attachments__label">
                              Alle zum Vertrag benötigten Unterlagen jetzt gesammelt herunterladen
                            </p>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </info-block>

            </div>
            <div class="form__links">
              <div class="container">
                <div class="form__btn">
                  <div class="form__btn-holder">
                    <button type="button" @click="submitBottom" class="btn btn--green btn--big finalSubmit" :disabled="downloadActive">
                      Versicherung kostenpflichtig abschließen
                      <ActivityIndicator v-if="downloadActive" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <p><br><br><br></p>
          </form>
        </section>
    </div>
</template>
<script>
import Crossselling from '../components/Crossselling.vue'
import ActivityIndicator from '../components/ActivityIndicator'
import InfoBlock from '../components/InfoBlock.vue'
import {sendApplication, setDate} from '../helpers/send.js'
import { jsPDF } from "jspdf";
import {entryChannel, setCampaign} from "@/vars";
import { saveAs } from 'file-saver';
import {fetchProductRoute} from "@/helpers/productApi";
import {puppy} from "../vars";

export default ({
  components: {
    Crossselling,
    InfoBlock,
    ActivityIndicator
  },
   model: {
        prop: 'leadin',
        event: 'leademit'
    },
    props: {
        registry: {
            type: Object,
            default() {
                return {}
        }},
        leadin: {
            type: Object,
            default() {
                return {}
        }}
    },
    data: () => ({
      productInfo: '',
      productName: '',
      productPrice: '',
      displayedPrice: '',
      paymentInterval : 'monatlich',
      cross: [],
      combiP: {id:'', name:'', price:''},
      crossP: {id:'', name:'', price:''},
      possCross: {},
      addPriceCombi: 0,
      addPriceCross: 0,
      accept: false,
      digitalCommunication: false,
      documentsDownloaded: false,
      downloadActive: false,
      pdf: '',
      pdfDS:'AGILA_Hinweise_zum_Datenschutz_für_Kunden_2024-04-03.pdf',
      foundOpen:false,
      howFoundID: false,
      brokerID: '',
      retPdf: '',
      preContractPdf: '',
      retraction: 'Widerrufsbelehrung',
      isBroker: false,
      errorEx: true,
      errorDocuments: true,
      sendWait: false,
      is24: false,
      errorExIdd: true,
      consultationText:'',
      consultationText2:'',
      idd: false,
      showIDD: true,
      openNews:true,
      early: false,
      sendCampaignPackage: [],
      crosssellingInfo: '',
      optimizely46: 0,
      tooltips: {
        combi: false
      },
      brokerList: [{'label': 'AMEXPool AG', 'value': '1093309 '}, {'label': 'Arisecur', 'value': '1118596'}, {'label': 'ARUNA', 'value': '1108921'},
        {'label': 'blaudirekt', 'value': '50300401'}, {'label': 'Conceptif', 'value': '1007843'}, {'label': 'Covomo', 'value': '1316941'},
        {'label': 'Fondsfinanz', 'value': '1154900'}, {'label': 'JUNG DMS (JDC)', 'value': '1206155'}, {'label': 'KD', 'value': '999'},
        {'label': 'Sales Agents', 'value': '99901'}, {'label': 'VEMA', 'value': '52000000'}],

      addagreement: false
    }),
    watch: {
        leadin: {
            immediate: true,
            handler (to) {
                this.race = to.race
                this.petbirthday = to.petbirthday
                this.petname = to.petname
                this.petgender = to.petgender
                this.petcolour = to.petcolour
                this.breed = to.breed
                this.brokerID = to.brokerID
                this.addagreement = to.addagreement
                this.country = to.country
                this.healthElements = to.healthElements
                this.symptomElements = to.symptomElements
                this.digitalCommunication = to.digitalCommunication
            }
        }
    },
    mounted: function() {
      if (window.optimizely46) {
        this.optimizely46 = window.optimizely46;
      }

      if (this.leadin.hash) {
        if (this.leadin.pre_conditions && this.leadin.pre_conditions.length && (!this.leadin.healthElements || !this.leadin.healthElements.length)) {
          fetchProductRoute(process.env.VUE_APP_API_ENDPOINT_PRODUCTS + 'condition-category?include=preConditions&filter[petTypeId]=' + this.leadin.race).then(response => {
            this.leadin.healthElements = [];
            this.leadin.pre_conditions.forEach(preCon => {
              let name = '';
              let catName = '';
              response.data.forEach(category => {
                category.pre_conditions.forEach(preCondition => {
                  if (preCondition.zvk_identifier === preCon.id) {
                    name = preCondition.name;
                    catName = category.name;
                  }
                })
              })

              this.leadin.healthElements.push({
                description: preCon.additional_information,
                status: preCon.treatment_status,
                occurrence: preCon.occurrence,
                conditionCategory: {
                  name: catName,
                },
                preCondition: {
                  id: preCon.id,
                  name: name,
                  zvk_identifier: preCon.id,
                }
              })
            })
            this.$forceUpdate();
          });
        }
        if (this.leadin.symptoms && this.leadin.symptoms.length && (!this.leadin.symptomElements || !this.leadin.symptomElements.length)) {
          let breeds = this.registry.dogbreedsByName
          if (this.leadin.race == 2) {
            breeds = this.registry.catbreedsByName
          }
          fetchProductRoute(process.env.VUE_APP_API_ENDPOINT_PRODUCTS + 'symptom?filter[petTypeId]=' + this.leadin.race + '&filter[breedIdent]=' + breeds[this.leadin.breed].breed_id).then(response => {
            this.leadin.symptomElements = [];
            this.leadin.symptoms.forEach(symptom => {
              this.leadin.symptomElements.push({
                id: symptom,
                name: response.data.find(res => res.id == symptom).name
              })
            });
            this.$forceUpdate();
          });
        }
      }

      window.onhashchange   = () => {
        if(window.location.hash.split('#')[2]  == 'zusammenfassung') {
          this.leadin.place = 4
        }

      }

      if (this.leadin.errorMessage == undefined) {
        this.leadin.errorMessage = {}
      }

      if(this.leadin.brokerID != undefined && ['99901', '99902', '99903', '99904', '99905', '99906', '99907'].includes(this.leadin.brokerID)) {
        this.showIDD = false
      }

      if (this.leadin.productActive == 11 || this.leadin.productActive == 16 || this.leadin.productActive == 4) {
        this.is24 = true
      }
      //this.productPrice = this.leadin.productPrice


      let matrix = this.getMatrix(this.leadin, this.registry, this.leadin.productActive);

      let seconds = this.calcAgeInSeconds(this.leadin.petbirthday)

      this.productPrice = parseFloat(this.calcPrice(matrix, seconds).toString().replace(/,/, '.'))

      // fix crossselling price on HPs for Sales-Agents response
      if(this.leadin.race == 1 && (this.leadin.hashR !== undefined && this.leadin.hashR == true)){
        if(this.registry.crossselling[this.leadin.cross] != undefined && this.registry.crossselling[this.leadin.cross]['cross1'] != undefined) {

          for(let i = 0; i < this.registry.crossselling[this.leadin.cross]['cross1'].length; i++) {
            if(this.registry.crossselling[this.leadin.cross]['cross1'][i]['id'] == this.leadin.productActive) {
              let priceRed = (this.registry.crossselling[this.leadin.cross]['cross1'][i]['cdiscount'] / 12).toFixed(2)
              this.productPrice = Number(this.productPrice) - priceRed
              break;
            }
          }
        }
      }
      this.productPrice = this.productPrice.toFixed(2)
      this.leadin.productPrice = this.productPrice

      this.brokerID = this.leadin.brokerID
      this.displayedPrice = this.productPrice

      if (typeof this.registry.crossselling[this.leadin.productActive] !== 'undefined'
          && typeof this.registry.crossselling[this.leadin.productActive]['cross1'] !== 'undefined') {

        let cross = []
        cross = this.registry.crossselling[this.leadin.productActive]['cross1']
        var t1 = new Date(this.leadin.petbirthday);
        var t2 = new Date();
        var dif = ( t2.getTime() - t1.getTime() ) / 1000;
        let y = 0;

        for (let i = 0; i < cross.length; i++) {

          if ((cross[i].id == 11 || cross[i].id == 4) && dif > 157680000) {
            continue;
          }

          if ((cross[i].id == 12 || cross[i].id == 3 || cross[i].id == 1 || cross[i].id == 2) && dif > 252288000) {
            continue;
          }

          this.cross[y] = cross[i]
          this.possCross[cross[i].id] = cross[i]
          y++;

        }

        if (typeof this.registry.crossselling[this.leadin.productActive]['combi'] !== 'undefined') {
            this.cross.push(this.registry.crossselling[this.leadin.productActive]['combi'][0])
        }
      }


      const country = {'Deutschland': 'DE', 'Österreich': 'AT'}
      this.pdf = this.registry.productMatrix.dog[this.registry.productByID[this.leadin.productActive].abbreviation].pdfs[country[[this.leadin.country]]]
      this.retPdf = 'AGILA_Vertragswerk_DE_Widerrufsbelehrung_2024-04-08.pdf'
      this.retraction = 'Widerrufsbelehrung'
      this.preContractPdf = 'AGILA-vorvertragliche-Infos-DE-06-2024.pdf';

      if (this.leadin.country == 'Österreich') {
        this.retPdf = 'AGILA_Belehrung_über_das_Rücktrittsrecht_AT_2024-04-03.pdf'
        this.retraction = 'Belehrung über das Rücktrittsrecht'
        this.pdfDS = 'AGILA_Hinweise_zum_Datenschutz_für_Kunden_AT_2024-04-03.pdf'
        this.preContractPdf = 'AGILA-vorvertragliche-Infos-AT-06-2024.pdf';
      }

      let startTime = '09:00:10';
      let endTime = '17:00:00';



      let startDate = new Date(t2.getTime());
      startDate.setHours(startTime.split(":")[0]);
      startDate.setMinutes(startTime.split(":")[1]);
      startDate.setSeconds(startTime.split(":")[2]);

      let endDate = new Date(t2.getTime());
      endDate.setHours(endTime.split(":")[0]);
      endDate.setMinutes(endTime.split(":")[1]);
      endDate.setSeconds(endTime.split(":")[2]);

      if(t2.getDay() === 6 || t2.getDay() === 0 || startDate > t2 || endDate < t2) {
        this.early  = true;
      }

      let crosssellingProduct = this.registry.productByID[this.leadin.crossselling]
      if (crosssellingProduct) {
        this.crosssellingInfo = crosssellingProduct.upsellingtext
      }
    },
    computed: {
      disclaimerText() {
        //const cosmosText = '<p class="tabs__text">Die Datenschutzhinweise habe ich zur Kenntnis genommen. Informationen zur Datenverarbeitung durch unseren Kooperations-partner CosmosDirekt können Sie hier abrufen.&nbsp;* Ja, ich möchte über Produkte und Services von Cosmos Finanzservice GmbH, Halbergstraße 50-60, 66121 Saarbrücken per Telefon bzw. E-Mail informiert werden und bin mit der Kontaktaufnahme zum Zwecke von Kundenzufriedenheitsbefragungen durch Cosmos oder ein beauftragtes Marktforschungsunternehmen einverstanden.</p><p class="tabs__text">Mir ist bekannt, dass ich meine Einwilligungserklärung jederzeit gegenüber Cosmos formlos (z. B. per E-Mail, schriftlich oder telefonisch) widerrufen kann. Ich bin einverstanden, dass die AGILA zu diesem Zweck meine Daten (E-Mail, Adressdaten, Telefonnummer) an ihren Kooperationspartner übermittelt.</p><p class="tabs__text">Die Datenschutzhinweise habe ich zur Kenntnis genommen. Informationen zur Datenverarbeitung durch unseren Kooperations-partner CosmosDirekt können Sie hier abrufen.&nbsp;* Ja, ich möchte über Produkte und Services von Cosmos Finanzservice GmbH, Halbergstraße 50-60, 66121 Saarbrücken per Telefon bzw. E-Mail informiert werden und bin mit der Kontaktaufnahme zum Zwecke von Kundenzufriedenheitsbefragungen durch Cosmos oder ein beauftragtes Marktforschungsunternehmen einverstanden.</p><p class="tabs__text">Mir ist bekannt, dass ich meine Einwilligungserklärung jederzeit gegenüber Cosmos formlos (z. B. per E-Mail, schriftlich oder telefonisch) widerrufen kann. Ich bin einverstanden, dass die AGILA zu diesem Zweck meine Daten (E-Mail, Adressdaten, Telefonnummer) an ihren Kooperationspartner übermittelt.</p>';

        if (this.leadin.country == 'Österreich') {
          return `<div class="tabs__text">
                  <p><strong>Anzeigepflicht: AGILA kann, wenn Sie Umstände (insb. Alter und Gesundheitszustand des Tieres), die in diesem Antrag abgefragt werden und die für den Entschluss von AGILA, den Vertrag wie vereinbart zu schließen, erheblich sind, vorsätzlich oder grob fahrlässig nicht angeben, vom Vertrag zurücktreten bzw. wenn Sie Ihre Anzeigepflicht einfach fahrlässig oder schuldlos verletzen, den Antrag innerhalb eines Monats nach Kenntnisnahme kündigen oder Vertragsanpassung verlangen.</strong></p>
                  <p>Für von AGILA gewünschte Auskünfte entbinde ich unseren Tierarzt mit Antragstellung von der Schweigepflicht. Hiervon unberührt bleibt die Möglichkeit, die erforderlichen Auskünfte/Unterlagen selbst beizubringen.</p>
                  <p>Ich versichere die Richtigkeit der von mir im Antrag gemachten Angaben.</p>
                </div>`
        }

        return `<div class="tabs__text">
                  <p><strong>Anzeigepflicht: AGILA kann, wenn Sie Umstände (insb. Alter und Gesundheitszustand des Tieres), die in diesem Antrag abgefragt werden und die für den Entschluss von AGILA, den Vertrag wie vereinbart zu schließen, erheblich sind, vorsätzlich oder grob fahrlässig nicht angeben, vom Vertrag zurücktreten bzw. wenn Sie Ihre Anzeigepflicht einfach fahrlässig oder schuldlos verletzen, den Antrag innerhalb eines Monats nach Kenntnisnahme kündigen oder Vertragsanpassung verlangen.</strong></p>
                  <p>Für von AGILA gewünschte Auskünfte entbinde ich unseren Tierarzt mit Antragstellung von der Schweigepflicht. Hiervon unberührt bleibt die Möglichkeit, die erforderlichen Auskünfte/Unterlagen selbst beizubringen.</p>
                  <p>Ich versichere die Richtigkeit der von mir im Antrag gemachten Angaben.</p>
                </div>`
      },

      puppyCheckbox() {
        return puppy;
      },

      seoIncentiveCheckbox() {
        return document.cookie.match('(^|;)\\s*seo_incentive\\s*=\\s*([^;]+)');
      },

      campaignCheckbox() {
        let isMarchCampaign = true;
        try {
          isMarchCampaign = (new Date().getMonth() === 2 || new Date().getMonth() === 3) && !this.leadin.isUDSelling;
        } catch (e) {
          console.log(e);
        }
        return isMarchCampaign;
      }

    },
    methods: {
      triggerChat(){
        const iframe  = document.querySelector('div[id^="userlike-"] iframe');
        if (iframe && iframe.contentWindow) {
          iframe.contentDocument.querySelector('button').click()
        }
      },
      logoPath() {
        return process.env.VUE_APP_ENV_URL;
      },
      back(place, where) {
        this.leadin.place = place
        this.leadin.jumpToEnd = true
        this.leadin.productPrice = this.productPrice
        history.pushState(null, null, '#' + window.location.hash.split('#')[1] + '#' + where)
        document.getElementById('jumppoint').scrollIntoView();

        return true
      },
      crosssellingCheck (data) {
        let cross = data.cross;
        let price = data.productPrice;
        let name = data.productName;

        const checkboxes = document.querySelectorAll('[data-cross]')

        if(cross.combi == 1 ) {
          this.combiP.id = cross.id
          this.combiP.name = name
          this.addPriceCombi = this.combiP.price = price
        }
        else {
          this.productPrice = (parseFloat(this.leadin.productPrice) - cross.pdiscount).toFixed(2)
          this.crossP.id = cross.id
          this.crossP.name = name
          this.addPriceCross = this.crossP.price = price
        }

        for(let checkbox in checkboxes) {
          if(isNaN(checkbox) || typeof checkboxes[checkbox].dataset == undefined) {
            continue;
          }
          else if (checkboxes[checkbox].dataset.cross == 1) {
            if(!checkboxes[checkbox].checked) {
              this.combiP.id = ''
              this.addPriceCombi = 0
            }

            continue
          }

          if (checkboxes[checkbox].dataset.id == cross.id) {
            if(!checkboxes[checkbox].checked) {
                this.productPrice = this.leadin.productPrice
                this.crossP.id = ''
                this.addPriceCross = 0
            }

            continue
          }

          this.pushDataLayer('ecommerce', 'kombi_option', name, this.crossP.id);

          if (checkboxes[checkbox].dataset.cross !== 1 && cross.combi != 1) {
            checkboxes[checkbox].checked = false;
          }
        }

        this.displayedPrice = (parseFloat(this.addPriceCross) + parseFloat(this.addPriceCombi) + parseFloat(this.productPrice)).toFixed(2)
        let crosssellingProduct = this.registry.productByID[cross.id]
        if (crosssellingProduct) {
          this.crosssellingInfo = crosssellingProduct.upsellingtext
        }

      },
      validate () {
        if (
            ((this.accept == true && this.showIDD && this.idd) || this.accept == true && !this.showIDD) &&
            (this.documentsDownloaded || ((this.brokerID && !this.leadin.hash) && (['1595114', '1606686', '1616388', '1656095'].includes(this.brokerID))))
        ) {
          return true;
        }
        if (this.accept != true) {
          this.errorEx = false
        }
        if (this.documentsDownloaded != true) {
          this.errorDocuments = false
        }

        if (this.showIDD && this.idd != true)  {
          this.errorExIdd = false
        }

        return false;
      },
      generateTrackingList(baseObject) {
        const itemList = [];

        if (baseObject.base) {
          Object.keys(baseObject).forEach(item => {
            if (item !== 'base' && baseObject[item]) {
              itemList.push(
                  item !== 'beschreibung'
                      ? item.charAt(0).toUpperCase() + item.slice(1)
                      : baseObject.beschreibung
              );
            }
          });
        }
        return itemList;
      },
      submitBottom() {
        if (!this.validate() || this.sendWait == true) {
          const el = document.getElementsByClassName('error')[0]
          const y = el.getBoundingClientRect().top + window.scrollY;
          window.scroll({
            top: y,
            behavior: 'smooth'
          });
          //el.scrollIntoView();
          return false;
        }

        this.leadin.crossselling = this.crossP.id
        this.leadin.combi = this.combiP.id
        this.leadin.brokerID = this.brokerID

        if(this.$ga == undefined) {
          this.$ga = {}
        }
        if (this.sendCampaignPackage.length) {
          setCampaign(Array.isArray(this.sendCampaignPackage) ? this.sendCampaignPackage[0] : this.sendCampaignPackage);
        }
        try {
          window['optimizely'] = window['optimizely'] || [];
          window['optimizely'].push({
            type: "event",
            eventName: "campaign_package_requested",
            tags: {
              value: this.sendCampaignPackage.length ? 1 : 0,
            }
          });
        } catch (e) {
          console.error(e);
        }
        this.leadin.cssIsHealthy = true
        this.leadin.renouncePress = false
        this.leadin.hidden = true
        this.leadin.doneIDD = false
        this.leadin.iddValidated = false
        this.leadin.preDamages = false
        this.leadin.hp24hidden = true
        this.leadin.noPre = false
        this.leadin.tk24hidden = true
        this.leadin.hasRun = true
        this.leadin.addagreement = this.addagreement
        this.leadin.digitalCommunication = this.digitalCommunication
        const saver = {'datetime': new Date(), 'data': this.leadin}

        if (this.leadin.digitalCommunication) {
          try {
            window['optimizely'] = window['optimizely'] || [];
            window['optimizely'].push({
              type: "event",
              eventName: "digital_communication_agree",
            });
          } catch (e) {
            console.error(e);
          }
        }

        // Tracking Start
        if (
            this.registry.cc &&
            (this.registry.cc.includes("gat") ||
                this.registry.cc.includes("all") ||
                this.registry.cc.includes("marketing"))
        ) {
          try {
            let symptoms_list = [];
            if (this.leadin.symptomElements && this.leadin.symptomElements.length) {
              this.leadin.symptomElements.forEach(symptom => {
                symptoms_list.push({
                  id: symptom.id,
                  name: symptom.name,
                })
              })
            }
            let treatment_list = [];
            if (this.leadin.treatmentBase) {
              this.leadin.healthElements.forEach(treatment => {
                treatment_list.push({
                  id: treatment.preCondition.id,
                  name: treatment.preCondition.name,
                  category: treatment.conditionCategory.name,
                  description: treatment.description,
                  status: treatment.status,
                  occurrence: treatment.occurrence
                })
              })
            }

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ecommerce: null})
            window.dataLayer.push({
              event: "purchase",
              ecommerce: {
                details: {
                  currency: "EUR",
                  value: Number(this.displayedPrice),
                  antragsstrecke_ueber: entryChannel,
                  payment: {
                    currency: "EUR",
                    value: Number(this.displayedPrice),
                    payment_type: this.leadin.paymentType,
                    payment_intervall: this.leadin.paymentinterval,
                    start_date: this.leadin.startDate,
                    product_name: this.leadin.productName,
                  },
                  customer: {
                    city: this.leadin.city,
                    country: this.leadin.country,
                    mail: this.leadin.email,
                    telefon: this.leadin.phone
                  },
                  pet: {
                    tierart: this.leadin.race == "1" ? "Hund" : "Katze",
                    rasse: this.leadin.breed,
                    alter: this.calculateAge(this.leadin.petbirthday),
                    geschlecht: this.leadin.petgender,
                    fellfarbe: this.leadin.petcolour,
                    rufname: this.leadin.petname,
                    symptoms_list: symptoms_list,
                    treatment: this.leadin.treatmentBase ? "ja" : "nein",
                    treatment_list: treatment_list,
                  },
                  options: {
                    addagreement: !!this.leadin.addagreement,
                    broker: this.leadin.brokerID
                  }
                },
                items: this.getTrackingProductItems(this.leadin.crossselling),
              }
            })
          } catch (e) {
            console.error(e);
          }
        }

        const response = sendApplication(this.leadin, this.registry)

        localStorage.setItem('leadData', JSON.stringify(saver));

        if(this.leadin.brokerID != undefined && ['99901', '99902', '99903', '99904', '99905', '99906', '99907'].includes(this.leadin.brokerID)) {
          localStorage.removeItem('leadData');
        }

        if (this.registry.cc && (this.registry.cc.includes('op') || this.registry.cc.includes('all') || this.registry.cc.includes('marketing'))) {
          try {
            window['optimizely'] = window['optimizely'] || [];
            window['optimizely'].push({
              type: "event",
              eventName: "purchase",
              tags: {
                revenue: Number(this.displayedPrice) * 100
              },
              properties: {
                number_of_products: this.leadin.crossselling ? 2: 1,
                product_type: this.registry.productByID[this.leadin.productActive].abbreviation,
              }
            });
          } catch (e) {
            console.error(e);
          }
        }
        // Tracking End

        if(response['isOK'] === true) {
          this.leadin.place = 5
          this.$parent.setPlace(5)
          document.getElementById('header').scrollIntoView();
          this.$emit('leademit', this.leadin)
        }
        else {
          this.catchLegbaError(response);
          return;
        }

        this.sendWait = true



      },
      getPDF(save = true) {

        const race = ['', 'Hund', 'Katze']
        const gender = ['', 'männlich', 'weiblich']
        const payment = {'ue': 'Überweisung', 'ls': 'Lastschrift'}

        const doc = new jsPDF({lineHeight: 1.5});
        const logo = require('@/assets/images/logo.png')
        var imgLogo = new Image()
        imgLogo.src = logo
        doc.addImage(imgLogo, 'PNG', 150, 10, 47, 17)
        doc.setTextColor(0, 78, 160)
        doc.setFontSize('11')
        doc.text("Ihr Antrag", 20, 35);
        doc.setTextColor(0, 0, 0)
        doc.setFontSize('6')
        const text = [
          'Guten Tag,',
          ' ',
          'auf der folgenden Seite finden Sie eine Zusammenfassung Ihrer bisher eingegebenen Daten und des ausgewählten Versicherungstarifs. Diese Informationen würden bei Abschluss',
          'eines Vertrages so an AGILA übermittelt werden. Bitte prüfen Sie Ihre Angaben und führen Sie gegebenenfalls Korrekturen durch, bevor Sie den Antrag für eine Versicherung',
          'abschicken.',
          ' ',
          'Mit freundlichen Grüßen',
          ' ',
          'Es grüßt sie ihre AGILA'

        ]
        doc.text(text, 20, 42);

        doc.setTextColor(0, 78, 160)
        doc.setFontSize('9')
        doc.text("Über Ihr Haustier", 20, 77);

        doc.setTextColor(0, 0, 0)
        doc.setFontSize('6')
        doc.text("Rufname", 20, 81);
        doc.text(this.leadin.petname, 90, 81);
        doc.text("Haustier", 20, 85);
        doc.text(race[this.leadin.race] + ' / ' + this.leadin.breed, 90, 85);
        doc.text("Geburtsdatum", 20, 89);
        doc.text(this.$options.filters.sortdate(setDate(this.leadin.petbirthday)), 90, 89);
        doc.text("Geschlecht", 20, 93);
        doc.text(gender[this.leadin.petgender], 90, 93);
        doc.text("Farbe", 20, 97);
        doc.text(this.leadin.petcolour, 90, 97);

        doc.setTextColor(0, 78, 160)
        doc.setFontSize('9')
        doc.text("Angaben zur Gesundheit", 20, 110);

        doc.setTextColor(0, 0, 0)
        doc.setFontSize('6')
        doc.text("Vorerkrankungen", 20, 114);
        doc.text(this.leadin.healthElements && this.leadin.healthElements.length ? this.leadin.healthElements.map(obj => obj.description || obj.preCondition.name).join(', ') : 'keine', 90, 114, {maxWidth: 100});
        doc.text("Symptome", 20, 122);
        doc.text(this.leadin.symptomElements && this.leadin.symptomElements.length ? this.leadin.symptomElements.map(obj => obj.name).join(', ') : 'keine', 90, 122);

        doc.setTextColor(0, 78, 160)
        doc.setFontSize('9')
        doc.text("Zu Ihrer Person", 20, 131);

        doc.setTextColor(0, 0, 0)
        doc.setFontSize('6')
        doc.text("Anrede", 20, 135);
        doc.text(this.leadin.gender, 90, 135);
        doc.text("Vorname / Nachname ", 20, 139);
        doc.text(this.leadin.firstname + ' ' + this.leadin.lastname, 90, 139);
        doc.text("Geburtsdatum", 20, 143);
        doc.text(this.$options.filters.sortdate(setDate(this.leadin.birthday)), 90, 143);
        doc.text("Straße", 20, 147);
        doc.text(this.leadin.street + ' ' + this.leadin.number, 90, 147);
        doc.text("PLZ / Stadt", 20, 151);
        doc.text(this.leadin.zip + ' ' + this.leadin.city, 90, 151);
        doc.text("Land", 20, 155);
        doc.text(this.leadin.country, 90, 155);
        doc.text("Telefon", 20, 159);
        doc.text(this.leadin.phone, 90, 159);
        doc.text("E-Mail", 20, 163);
        doc.text(this.leadin.email, 90, 163);

        doc.setTextColor(0, 78, 160)
        doc.setFontSize('9')
        doc.text("Beitragszahlung", 20, 172);


        if (this.leadin.paymentType === undefined) {
          this.leadin.paymentType = 'ue'
        }

        doc.setTextColor(0, 0, 0)
        doc.setFontSize('6')
        doc.text("Bezahlung", 20, 176);
        doc.text(payment[this.leadin.paymentType], 90, 176);

        doc.setTextColor(0, 78, 160)
        doc.setFontSize('9')
        doc.text("Ausgewählte Produkte", 20, 185);

        doc.setTextColor(0, 0, 0)
        doc.setFontSize('6')

        let products = [this.leadin.productActive]

        if (this.crossP.id !== '') {
          products.push(this.crossP.id.toString())
        }

        if (this.combiP.id !== '') {
          products.push(this.combiP.id.toString())
        }

        let position = 189

        const racee = ['', 'dog', 'cat']

        let matrix = this.registry.productMatrix[racee[this.leadin.race]];

        let breeds = this.registry.dogbreedsByName

        if (this.leadin.race == 2) {
          breeds = this.registry.catbreedsByName
        }

        const breedName = Object.keys(breeds).find(breed => breeds[breed].breed_id === Number(this.leadin.breed_id));
        if (breedName) {
          this.breed_class_id = breeds[breedName].breed_class_id
          this.sickness_prone = breeds[breedName].sickness_prone
        }
        let seconds = this.calcAgeInSeconds(this.leadin.petbirthday)

        let matrixS = []
        let price = 0
        let c = 0;

        for (let productId of products) {
          doc.text(this.registry.productByID[productId].title, 20, position)

          if (matrix[this.registry.productByID[productId].abbreviation]['matrix'][0] !== undefined && this.leadin.race == 1) {
            matrixS = matrix[this.registry.productByID[productId].abbreviation]['matrix'][0]
          } else {
            matrixS = matrix[this.registry.productByID[productId].abbreviation]['matrix'][this.breed_class_id]
          }

          price = this.calcPrice(matrixS, seconds)

          if (c == 0) {
            price = this.productPrice
          } else if (c > 0 && this.possCross[productId] != undefined && this.possCross[productId].cdiscount != 0) {
            price = (price - (this.possCross[productId].cdiscount / 12)).toFixed(2)
          }

          doc.text('€ ' + this.$options.filters.replacePoint(price), 90, position);
          position += 4
          c = this.leadin.productActive;
        }

        doc.text("Vertragsbeginn", 20, position);
        doc.text(this.$options.filters.sortdate(setDate(this.leadin.startDate)), 90, position);

        doc.setFontSize('5')

        const text2 = [
          'AGILA Haustierversicherung AG',
          'Vorstand: Marco Brandt, Gerlach Schreiber, Peter Klingspor | Aufsichtsratsvorsitzender: Patrick Döring | Amtsgericht Hannover HR B 54594 | Internet: www.agila.de',
          '30003 Hannover | Breite Straße 6-8 | 30159 Hannover | Commerzbank Hannover | IBAN DE58 2504 0066 0450 0393 00 | BIC COBADEFFXXX',
          'USt-ID-Nr. DE813565388 | Alle Daten werden elektronisch gespeichert | Leistungen auf Grund eines Versicherungsverhältnisses i.S. des Versicherungsteuergesetzes',
          'sind nach § 4 Nr. 10 a UStG umsatzsteuerfrei | Hinweise zum Beschwerdemanagement und zu möglichen alternativen Streitbeilegungsverfahren finden Sie unter www.agila.de'
        ]
        doc.text(text2, 20, 270);

        if (save) {
          doc.save("Ihr_Antrag.pdf");
        } else {
          return doc.output('blob');
        }
      },
      async downloadAllDocuments() {
        try {
          this.downloadActive = true;
          const response = await fetch(process.env.VUE_APP_API_ENDPOINT_DOCUMENTS + 'pdf/contract-information?country=' + (this.leadin.country === 'Österreich' ? 'at' : 'de'), {
            method: 'post',
            body: this.getPDF(false),
            headers: {
              'client-key': process.env.VUE_APP_CLIENT_KEY_DOCUMENTS
            }
          });
          const blob = await response.blob();
          saveAs(blob, 'Vertragsunterlagen-AGILA.pdf');

          this.documentsDownloaded = true;
          this.errorDocuments = true;
          this.downloadActive = false;
        } catch (e) {
          console.log(e);
          this.documentsDownloaded = true;
          this.errorDocuments = true;
          this.downloadActive = false;
        }
      },
      catchLegbaError(error) {
        const errorList = {
          '3003': {
            'place': 3,
            'hook': 'zahlung',
            'field': 'startdate',
            'message': 'Das Startdatum liegt in der Vergangenheit',
            'label': 'Vertragsbeginn'

          },
          '3011': {
            'place': 3,
            'hook': 'zahlung',
            'field': 'startdate',
            'message': 'Das Startdatum liegt zu weit in der Zukunft',
            'label': 'Vertragsbeginn'

          },
          '2005' : {
            'place': 0,
            'hook': 'tier',
            'field': 'petbirthday',
            'message': 'Das Tier ist zu jung',
            'label': 'Geburtsdatum'
          },
          '2008' : {
            'place': 0,
            'hook': 'tier',
            'field': 'petcolour',
            'message': 'Die Fellfarbe des Tieres ist nicht gesetzt',
            'label': 'Fellfarbe'
          },
          '1003' : {
            'place': 1,
            'hook': 'person',
            'field': 'email',
            'message': 'Ihre E-Mail Adresse ist not valide',
            'label': 'E-Mail Adresse'
          },
          '1004' : {
            'place': 1,
            'hook': 'person',
            'field': 'phone',
            'message': 'Ihre Telefonnummer enthält ungültige Zeichen',
            'label': 'Telefonnummer'
          },
          '1010' : {
            'place': 1,
            'hook': 'person',
            'field': 'zip',
            'message': 'Es wurde keine Postleitzahl angegeben',
            'label': 'PLZ'
          },
          '4002' : {
            'place': 3,
            'hook': 'zahlung',
            'field': 'sepa',
            'message': 'Sie müssen das Sepa-Mandat erteilen',
            'label': 'Ich bestätige die Erteilung des SEPA-Lastschrift-Rahmenmandats wie folgt'
          },
          '9000' : {
            'place': 3,
            'hook': 'tier',
            'field': 'race',
            'message': 'Es ist ein Datenbankfehler aufgetreten. Versuchen Sie es bitte zu einem späteren Zeitpunkt erneut.',
            'label': 'Hund'
          },

        }

        if (errorList[error] != undefined) {
          this.back(errorList[error]['place'], errorList[error]['hook'])
          this.leadin.errorMessage = errorList[error]
          this.leadin.errorMessage[this.leadin.errorMessage.field] = 'invalid'
        }
        if (error == "2002") {
          this.back(errorList[error]['place'], 'tier')
          this.leadin.errorMessage = errorList[error]
          // how to invalidate a field? Robert fragen.

        }
        /*
        Array
(
    [0] => Array
        [['Not a valid Request'], [410]]
                (
                    [0] => Not a valid Request
                )

            [1] => Array
                (
                    [0] => 410
                )

        )

    [1] => 400
)



1001: Customer Gender
1002: No complete name given
1003: E-Mail-Adress not Valid
1004: Phone-Number not valid
1005: Customer Birthdate not given
1006: Customer is too young
1007: Birthdate is not valid
1008: Address: Street not given
1009: Address: Street-number not give
1010: Address: Zipcode not give
1011: Address: City not give
1012: Address: Country incorrect

2001: Pet-Gender not correctly set
2002: Pet-Name not given
2003: No Valid Pet-Type given
2004: Pet-Birthdate not given
2005: Pet Birthdate is too young
2006: Pet birthdate is too old
2007: Pet-Health is not set
2008: Pet-Color is not set
2009: Pet-Color is wrong
2010: No Breed given
2011: Pet birthdate is not valid
2012: Breed not valid
2013: Second Breed not valid

3001: No Product given
3002: Given Product is not correct
3003: Start Date set in Past
3004: Previous Damage set wrongly
3005: Pet caused previous damage
3006: Vet-Name not correct
3007: Vet-Street not correct
3008: Vet-Street-number not correct
3009: Vet-Zipcode not correct
3010: Vet-City not correct

4001: No correct Payment-Type set
4002: SEPA-Mandate not given
4003: Correct IBAN required
4004: No correct payment interval set
*/
      },
    }
})


</script>

<style scoped>
.steps-list li .steps-list__info-item {
    display:none;
}
.steps-list__info-edit {
    display:none;
}
.show { display:block !important}
.open-close__link {
  color: #014e9e;
}
.open-close .open-close__link.active .icon-down-arrow {
    -webkit-transform: rotate(-180deg);
    -ms-transform: rotate(-180deg);
    transform: rotate(-180deg);
}
.hidden{
  display:none;
}
.tabs__info .jcf-scrollable {
  width:100%;
}
.icon.set-fas .glyph {
  font-family: "fa-solid-900", "Font Awesome 5 Free";
  font-weight: 900;
  font-size: 16px;
  color: red;
}
.error {
  margin-left:5px;
  font-size: 14px; color: red;
}
.error-block {
  display:inline-block;
  margin:10px 0;
}
span.explain{
  margin-top:10px;
  margin-left:30px;
  line-height:21px;
}
.checkbox-subtext {
  margin-left: 31px;
}
</style>
<style>
.indent {
  margin-left:30px;
}

.input-control .wrapper {
  min-height:50px !important;
}
.wrapper.checkbox label.checkbox {
  padding:15px !important;
}
ul.tabs__text{
  list-style-type: square;
  list-style-position: outside;
  margin-left: 12px;
  line-height: 1.1em;
}
ul.tabs__text li{
  margin-bottom:10px;
}
.just {
  text-align: justify;
  text-justify: inter-word;
}

.agreement__attachments ul {
  flex-wrap: wrap;
}

.agreement__attachments ul li {
  padding-right: 20px;
}

.agreement__confirmation * {
  text-align: justify;
}
.pad-right {
  padding-right:15px;
}
.hand {
  cursor: pointer;
  color: rgb(1, 78, 158);
}
ol.ol {
  list-style-type: decimal;
  list-style-position: inside;

}
@media (max-width: 599px) {
    .form--medium.form--unlarge {
        width:90%;
    }
}
.finalSubmit {
  display: flex;
  justify-content: center;
  align-items: center;
}
.web-loader div {
  border-color: #ffffff !important;
  margin-left: 10px;
  width: 23px !important;
  height: 23px !important;
}

.incentive .checkbox.control.type-radio {
  padding: 5px 0;
  display: flex;
  flex-flow: nowrap;
}
.incentive .checkbox.control.type-radio .label {
  color: #7f7f7f;
}
</style>
